import { useQuery } from "@tanstack/react-query";
import { queryService } from "@/api/services/query-service";
import { QueryKeys } from "@/api/config/query-keys";

interface UseSiteConfigsOptions {
  enabled?: boolean;
}

export const useSiteConfigs = (options?: UseSiteConfigsOptions) => {
  return useQuery({
    queryKey: QueryKeys.SITE_CONFIGS.categories(),
    queryFn: () => queryService.getSiteConfigs(),
    staleTime: 5 * 60 * 1000, // 5 dakika
    gcTime: 10 * 60 * 1000, // 10 dakika
    enabled: options?.enabled ?? true, // Default true (backward compatibility)
  });
};
